import { countryProfile, normaliseUiLocale, type CountryProfile, type UiLocale } from '@his/shared';
import { display } from './utils';

export function activeProfile(): CountryProfile {
  return countryProfile(display.country);
}

export const LANGUAGE_NAMES: Record<UiLocale, string> = {
  en: 'English',
  ar: 'العربية',
  es: 'Español',
  'ur-Latn': 'Roman Urdu',
};

export function languageOptions(profile: CountryProfile): { value: UiLocale; label: string }[] {
  const offered = new Set<UiLocale>(['en', ...profile.locales.ui]);
  return [...offered].map((value) => ({ value, label: LANGUAGE_NAMES[value] }));
}

let cachedCountries: { key: string; list: { code: string; name: string }[] } | null = null;

export function isoCountries(uiLocale: string | null | undefined = 'en'): { code: string; name: string }[] {
  const locale = normaliseUiLocale(uiLocale) === 'ur-Latn' ? 'en' : normaliseUiLocale(uiLocale);
  if (cachedCountries?.key === locale) return cachedCountries.list;
  const names = new Intl.DisplayNames([locale], { type: 'region', fallback: 'none' });
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const list: { code: string; name: string }[] = [];
  for (const first of letters) {
    for (const second of letters) {
      const code = `${first}${second}`;
      try {
        const name = names.of(code);
        if (name && name !== code && !/^[A-Z]{2}$/.test(name)) list.push({ code, name });
      } catch {
        continue;
      }
    }
  }
  const excluded = new Set(['EU', 'EZ', 'UN', 'QO', 'XA', 'XB', 'ZZ', 'AA', 'QM', 'QN', 'QP', 'QQ', 'QR', 'QS', 'QT', 'QU', 'QV', 'QW', 'QX', 'QY', 'QZ']);
  const filtered = list.filter((entry) => !excluded.has(entry.code) && !entry.code.startsWith('X')).sort((a, b) => a.name.localeCompare(b.name));
  cachedCountries = { key: locale, list: filtered };
  return filtered;
}
